import React from "react";
import { Button } from "react-materialize";
import FormFunc from "../../../utils/FormFunc";
// import Feature from "../../../utils/Feature";
import { useInfo } from "context/InfoContext";

export default function EmpEleaveContent({ boxName, userData, handleEvents }) {
  const { infos, filters, filterData } = useInfo();
  let addClass = "col s6";
  const isCannotEdit =
    userData?.user_sess?.userCanAccessHrAssign ||
    userData?.user_sess?.isAdmin ||
    userData?.idu === filters?.idu
      ? false
      : true;
  const isEditProfile = Boolean(filters?.idu);
  // console.log("filters:", filters);
  // console.log("infos:", infos);
  // console.log("isEditProfile:", isEditProfile);
  return (
    <div key={"outer-" + boxName + "-" + filters.key_form}>
      <div
        className={boxName + " row"}
        style={{
          borderTop: "2px solid #dcdbdb",
          paddingTop: "20px",
          marginBottom: "15px",
        }}
      >
        <FormFunc.SingleSelect
          data={{
            name: "eleave_approver",
            label: "E-leave approver (manager's email)*",
            options: filterData.data.approvers,
            addClass: addClass,
            optionName: "approver_name_and_email",
            optionValue: "approver_id",
            optionTitle: "---",
            optionNull: true,
            defaultValue: filters?.eleave_approver ?? "",
            required: true,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "eleave_co_approver",
            label: "E-leave Co-approver",
            options: filterData.data.approvers,
            addClass: addClass,
            optionName: "approver_name_and_email",
            optionValue: "approver_id",
            optionTitle: "---",
            optionNull: true,
            defaultValue: filters?.eleave_co_approver ?? "",
            required: false,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"}>
        <FormFunc.SingleSelect
          data={{
            name: "kpi_approver",
            label: "KPI Approver",
            options: filterData.data.approvers,
            addClass: addClass,
            optionName: "approver_name_and_email",
            optionValue: "approver_id",
            optionTitle: "---",
            optionNull: true,
            defaultValue: filters?.kpi_approver ?? "",
            required: false,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "kpi_co_approver",
            label: "KPI Co-approver",
            options: filterData.data.approvers,
            addClass: addClass,
            optionName: "approver_name_and_email",
            optionValue: "approver_id",
            optionTitle: "---",
            optionNull: true,
            defaultValue: filters?.kpi_co_approver ?? "",
            required: false,
            disabled: isCannotEdit,
          }}
          filters={filters}
          events={handleEvents}
        />
      </div>
      {!isCannotEdit &&
        !isEditProfile &&
        infos.tabActive === "employeeinfo" && (
          <div
            className={`${boxName} row`}
            style={{ textAlign: "center", marginTop: "25px" }}
          >
            <Button
              id="btn-next"
              node="button"
              waves="light"
              style={{ width: "150px" }}
              onClick={handleEvents.OnNext}
            >
              Next
            </Button>
          </div>
        )}
      {!isCannotEdit &&
        !(!isEditProfile && infos.tabActive === "employeeinfo") && (
          <div
            className={`${boxName} row`}
            style={{ textAlign: "center", marginTop: "25px" }}
          >
            <Button
              id="btn-save"
              node="button"
              waves="light"
              style={{ width: "150px" }}
              onClick={handleEvents.OnSave}
            >
              Save
            </Button>
          </div>
        )}
    </div>
  );
}
